export default __webpack_public_path__ + "static/media/PocketeBooks.ebef8fb7.png";